import React from 'react';
import { StepProps } from '../MultiStepModal';

export default function JobNotesStep({ data, onDataChange }: StepProps) {
  return (
    <div className="step-form">
      <div className="step-header">
        <h3 className="step-form-title">Attachments & notes</h3>
        <p className="step-form-subtitle">Add any special instructions or notes for the engineer.</p>
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-[11px] font-medium text-[#374151] mb-1">Special instructions</label>
          <textarea
            rows={4}
            placeholder="Access codes, parking info, hazards, contact on arrival…"
            value={data.notes || ''}
            onChange={e => onDataChange({ notes: e.target.value })}
            className="w-full rounded-lg border border-[#E6E6E4] px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-[#1B1B1B] resize-none"
          />
        </div>

        {/* File upload placeholder — browser FileList not persisted to backend yet */}
        <div className="rounded-xl border-2 border-dashed border-[#E6E6E4] px-5 py-6 text-center">
          <div className="text-2xl mb-2">📎</div>
          <p className="text-[12px] font-medium text-[#374151]">Attachments</p>
          <p className="text-[11px] text-[#9CA3AF] mt-1">Photos, PDFs, and documents can be added after the job is created via the job detail view.</p>
        </div>
      </div>
    </div>
  );
}
